import { useEffect, useState, useCallback } from "react";

/**
 * Gestiona la confirmación de descarte al salir con cambios sin guardar.
 *
 * - Atacha window.onbeforeunload cuando dirty=true (red de seguridad para cerrar tab).
 * - Expone requestLeave(onConfirm): si dirty abre el dialog, si no ejecuta onConfirm.
 * - Expone estado del dialog (open, onSeguirEditando, onDescartar) para renderizar.
 */
export const useConfirmDiscard = ({ dirty }) => {
  const [open, setOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty]);

  const requestLeave = useCallback(
    (onConfirm) => {
      if (!dirty) {
        onConfirm();
        return;
      }
      setPendingAction(() => onConfirm);
      setOpen(true);
    },
    [dirty],
  );

  const onSeguirEditando = useCallback(() => {
    setOpen(false);
    setPendingAction(null);
  }, []);

  const onDescartar = useCallback(() => {
    setOpen(false);
    if (pendingAction) pendingAction();
    setPendingAction(null);
  }, [pendingAction]);

  return { requestLeave, dialogOpen: open, onSeguirEditando, onDescartar };
};
